export default "__VITE_ASSET__Do1HJuUO__"